module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.wood.co2.flux.3583f2a7.png";